<template>
  <b-table
    responsive
    :items="items"
    :fields="fields"
    class="mb-0"
  >
    <template #cell(Phone)="data">
      <span class="text-nowrap">
        {{ data.value }}
      </span>
    </template>

    <!-- Optional default data cell scoped slot -->
    <template #cell()="data">
      {{ data.value }}
    </template>
  </b-table>
</template>

<script>
import { BTable } from 'bootstrap-vue'

export default {
  components: {
    BTable,
  },
  data() {
    return {
      fields: [
        'cihaz_no',
        'Reaktife_Giren_Tarih',
        'Reaktif_Bedeli',
        'trafo_no',
        'toplam_Tuketim_KWH',
        {
          key: 'İletişim_No', label: 'Phone',
        },
        'Sektör',
      ],
      items: [
        {
          cihaz_no: '1',
          Reaktife_Giren_Tarih: '28/06/2022 16:40',
          Reaktif_Bedeli: '0',
          email: 'mdellascala0@opensource.org',
          trafo_no: 'TR38',
          toplam_Tuketim_KWH: '32.4597',
          İletişim_No: '+90 555 555 55 55 ',
          Sektör: 'Atık-Geri Dönüşüm',

        },

      ],
    }
  },
}
</script>
